import React, { useEffect } from "react";
import Seo from "../../shared/seo/Seo";
import { urls, copy, currentLang } from "../../shared/seo/links";
import SearchHome from "../../components/home/SearchHome";
import HowToFindLawyer from "../../components/home/HowToFindLawyer";
import BlogSection from "../../components/home/BlogSection";
import QuestionsSection from "../../components/home/QuestionsSection";
import JoinAsLawyer from "../../components/home/JoinAsLawyer";
import BlogProvider from "../../shared/context/BlogContext";
import QuestionProvider from "../../shared/context/QuestionContext";
/**
 * The same identity the server renderer gives the home page: an
 * Organization (a directory and publisher, not a law firm, so not a
 * LegalService) with its official profiles in sameAs (none yet), and the
 * WebSite it publishes.
 */
export function homeJsonLd(lang) {
  const origin = window.location.origin;
  const home = urls.absoluteUrl(origin, urls.homePath(lang));
  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${urls.absoluteUrl(origin, "/")}#organization`,
    name: copy.SITE_NAME,
    url: urls.absoluteUrl(origin, "/"),
    logo: { "@type": "ImageObject", url: urls.absoluteUrl(origin, "/icon.png") },
    areaServed: { "@type": "Country", name: "Tunisia" },
    sameAs: [],
  };
  return [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${home}#website`,
      name: copy.SITE_NAME,
      url: home,
      inLanguage: lang,
      publisher: { "@id": organization["@id"] },
    },
    organization,
  ];
}

export default function Home() {
  const lang = currentLang();
  useEffect(() => {
    function isMobile() {
      if (navigator.userAgent === "AvoconsulteApp") {
        window.location.replace("/login");
        return true;
      } else {
        return false;
      }
    }
    isMobile();
  }, []);
  function isMobile() {
    if (navigator.userAgent === "AvoconsulteApp") {
      window.location.replace("/login");
      return true;
    } else {
      return false;
    }
  }
  return isMobile() ? null : (
    <>
      <Seo
        title={copy.home(lang).title}
        description={copy.home(lang).description}
        path={urls.homePath(lang)}
        alternates={urls.alternates(urls.homePath)}
        jsonLd={homeJsonLd(lang)}
      />
      <SearchHome />
      <HowToFindLawyer />
      {/* Restyles the shared section headers of the content sections. */}
      <div className="avc-home-content">
        <QuestionProvider>
          <QuestionsSection />
        </QuestionProvider>
        <BlogProvider>
          <BlogSection />
        </BlogProvider>
      </div>
      <JoinAsLawyer />
    </>
  );
}
